module.exports = __webpack_public_path__ + "static/media/game-logs-icon.bc12eb18.svg";